<template>
  <div class="token-expired-container">
    <div class="message-box">
      <h1>{{ $t('sesion_expirada') }}</h1>
      <p>{{ $t('mensaje_sesion_expirada') }}</p>
      <button @click="redirectToLogin" class="btn-login">{{ $t('ir_a_login') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenExpiredView',
  methods: {
    redirectToLogin() {
      // Limpiar token/datos de sesión y redirigir al login
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('user_name');
      sessionStorage.removeItem('user_role');
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.token-expired-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.message-box {
  text-align: center;
  background-color: white;
  padding: 20px 40px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.message-box h1 {
  font-size: 24px;
  color: #99172A;
  margin-bottom: 10px;
}

.message-box p {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}

.btn-login {
  background-color: #99172A;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-login:hover {
  background-color: #7A1222;
}
</style>